import { getNumber, getString } from 'shared-base';

const navbarWidthLeft = getNumber('navbarWidthLeft') || 210;
const navbarWidthRight = getNumber('navbarWidthRight') || 210;
const artStyle = (getString('artStyle') || 'stylized') as ArtStyle;
const subdomains: Record<string, Site> = { admin: 'admin', platform: 'platform', 'v2.app': 'web' };
const subdomain = window.location.hostname.split('.')[0];
const site = subdomains[subdomain] || 'web';

export const appState: IAppState = {
  version: '0.0.0',
  path: '',
  isAuthenticated: false,
  isLoading: true,
  isLoadingFresh: true,
  isAiRunning: false,
  showLogs: false,
  isDataReady: false,
  editMode: 'object',
  isUnityReady: false,
  tsStartExternal: 0,
  externalGlb: '',
  isSlimVersion: false,
  isAdhocRunning: false,
  navbarWidthLeft,
  navbarWidthRight,
  showGuidance: false,
  showPlaygroundWarning: true,
  isCharging: false,
  artStyle,
  q: '',
  tag: '',
  site,
  aiExplanation: '',
};
